import cn from "classnames";
import { ButtonHTMLAttributes, CSSProperties, MouseEventHandler, ReactNode } from "react";
import { BUTTON_NEXT_ID } from "~/configs/consts";
import { LoadingContainer } from "~/containers/loading-сontainer";

import styles from "./CustomButton.module.scss";

interface CustomButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  name: string;
  description?: string;
  style?: CSSProperties;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  classNameIcon?: string;
  isLoading?: boolean;
  icon?: ReactNode;
  iconPosition?: "before" | "after";
}

export const CustomButton: React.FC<CustomButtonProps> = ({
  name,
  description,
  style,
  onClick,
  className,
  classNameIcon,
  isLoading = false,
  type = "button",
  disabled = false,
  icon,
  iconPosition = "after",
  id = BUTTON_NEXT_ID,
  ...props
}) => {
  return (
    <button
      {...props}
      style={style}
      onClick={onClick}
      className={cn(styles.button, className, {
        [styles.buttonDisabled]: isLoading || disabled,
      })}
      type={type}
      disabled={disabled}
      id={id}
    >
      <LoadingContainer isLoading={isLoading}>
        {icon && iconPosition === "before" && (
          <span className={cn(styles.icon, classNameIcon)}>{icon}</span>
        )}

        <div className={styles.containerText}>
          <span className={styles.text}>{name}</span>
          <span className={styles.description}>{description}</span>
        </div>

        {icon && iconPosition === "after" && (
          <span className={cn(styles.icon, classNameIcon)}>{icon}</span>
        )}
      </LoadingContainer>
    </button>
  );
};